// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__wh40O"};